import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import Tabs from './Tabs/Tabs';
import Container from './Container/Container';
import Tab from './Tabs/Tab/Tab';

const TabsSectionContext = React.createContext();

class TabsSection extends Component {
  static propTypes = {
    children: PropTypes.node
  }

  static Tabs = Tabs;
  static Container = Container;
  static Tab = Tab;

  state = { activeTab: 1 };

  tabListRef = createRef();
  totalTabElements = null;

  componentDidMount = () => {
    this.totalTabElements = this.tabListRef.current.childElementCount;
  }

  handleClick = (e) => {
    e.preventDefault();
    const activeTab = e.currentTarget.dataset.key;

    this.setState({ activeTab: parseInt(activeTab, 10) });
  }

  getPreviousTab = (totalTabElements) => {
    const { activeTab } = this.state;
    const previousTab = activeTab - 1;

    return previousTab <= 0 ? totalTabElements : previousTab;
  }

  getNextTab = (totalTabElements) => {
    const { activeTab } = this.state;
    const nextTab = activeTab + 1;

    return nextTab > totalTabElements ? 1 : nextTab;
  }

  handleKeyDown = (e) => {
    let nextActiveChild;

    switch(e.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextActiveChild = this.getPreviousTab(this.totalTabElements);
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        nextActiveChild = this.getNextTab(this.totalTabElements);
        break;
      default:
        return;
    }

    this.setState({
      activeTab: nextActiveChild
    });
  }

  render () {
    return (
      <TabsSectionContext.Provider
        value={{
          activeTab: this.state.activeTab,
          handleClick: this.handleClick,
          handleKeyDown: this.handleKeyDown,
          tabListRef: this.tabListRef
        }}>
        {this.props.children}
      </TabsSectionContext.Provider>
    );
  }
}

export const TabsSectionConsumer = TabsSectionContext.Consumer;
export default TabsSection;



// WEBPACK FOOTER //
// ./src/uis/elements/Tabs/TabsSection/TabsSection.js